const fromResponse = response => response;

export default fromResponse;
